// Module
var code = `<app-page-content
        [showWebFooter]="true"
        [usePagePadding]="true"
        [pmcId]="paymentRequest.property.hoa.pmc.couponId"
        [hoaId]="paymentRequest.property.hoa.couponId"
        [propertyId]="paymentRequest.property.couponId">
    <app-cobrand-header
            [property]="paymentRequest.property.nickname"
            [manager]="paymentRequest.property.hoa.pmc.name"
            [association]="paymentRequest.property.hoa.name"
            [makePayment]="true">
    </app-cobrand-header>
    <div class="HOA-container">
        <div class="HOA-container__header">
            <div class="HOA-container__header-text" tid="pageTitle" id="pageTitle">Payment Cancelled</div>
        </div>
        <div class="HOA-container__content HOA-misc-guidedSteps__flex-extra-padded u-textCenter">
            <div class="u-pT4 u-pB4">
                <div tid="paymentCancelledLabel"
                     id="paymentCancelledLabel"
                     class="u-pB2">
                            <span>
                                Your payment for {{paymentRequest.payment.totalPaymentAmount | currency}} was successfully cancelled.
                            </span>
                </div>
                <div tid="confirmationLabel"
                     id="confirmationLabel"
                     class="u-pB5">
                    A confirmation email has been sent to email address {{email}}.
                </div>
                <div tid="confirmationNumberLabel"
                     id="confirmationNumberLabel"
                     class="u-pB4">
                    Confirmation #{{paymentConfirmationNumber}}
                </div>
            </div>
            <div class="HOA-flex-component HOA-flex-component__column-center">
                <div class="HOA-flex-component HOA-guest-payment-button-container">
                    <button tid="printSuccessButton"
                            id="printSuccessButton"
                            class="Button Button--outline"
                            (click)="clickPrint()">
                        Print
                    </button>
                    <button tid="okButton"
                            id="okButton"
                            class="Button Button--blue"
                            ifOverFlowXClass="Button--overflowX"
                            (click)="goToPropertiesPage()">
                        Continue
                    </button>
                </div>
            </div>
        </div>
    </div>
</app-page-content>`;
// Exports
module.exports = code;